import { Avatar, type AvatarProps } from "@mui/material";
import type { FC } from "react";
import type { TimelineItemResponseDTO } from "web_myplann/Infrastructure/Api/Api";
import {
	getTimelineIconSpec,
	type TimelineIconTone,
} from "web_myplann/NotificationCenter/Utils/getTimelineIconSpec";

interface CategoryIconProps {
	item: Pick<TimelineItemResponseDTO, "category" | "subcategory">;
}

const TONE_VARIANT: Record<TimelineIconTone, AvatarProps["variant"]> = {
	teal: "softTeal",
	green: "softGreen",
	orange: "softOrange",
	blue: "softBlue",
	purple: "softPurple",
	grey: "softGrey",
};

const ICON_SIZE = 20;

export const CategoryIcon: FC<CategoryIconProps> = ({ item }) => {
	const { Icon, tone } = getTimelineIconSpec(item);

	return (
		<Avatar variant={TONE_VARIANT[tone]}>
			<Icon size={ICON_SIZE} />
		</Avatar>
	);
};
